"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRootDomain = getRootDomain;
exports.parseBaseDomain = parseBaseDomain;
var _base = require("./base.functions");
// A targeted list of internally supported ccSLDs
// to avoid fetching a large public suffix list
const secondLevelDomains = ['co.uk', 'co.jp', 'com.au'];

// Regex to match the domain and optional TLDs, ignoring protocol and subdomains
const pattern = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+)/;

/**
 * Parse base domain from url with protocols, subdomains, ports, and multi-part TLDs
 * @param {string} url - URL to parse
 * @returns {string} baseDomain
 * @description Parses the base domain from a url
 * @example parseBaseDomain('www.godaddy.com') => 'godaddy.com'
 * @example parseBaseDomain('https://ae.dev-godaddy.com/ar') => 'dev-godaddy.com'
 * @example parseBaseDomain('https://local.gasket.dev-godaddy.com') => 'dev-godaddy.com'
 * @example parseBaseDomain('https://www.123reg.co.uk') => '123reg.co.uk'
 */
function parseBaseDomain(url) {
  const match = url?.match(pattern);
  if (match) {
    const parts = match[1].split('.');
    const lastTwoParts = parts.slice(-2).join('.');

    // By default, slice the last two parts
    let sliceStart = -2;
    if (secondLevelDomains.includes(lastTwoParts)) {
      sliceStart = -3;
    }
    return parts.slice(sliceStart).join('.');
  }
  return null;
}

/**
 * @param {string} env - ENV the app is running. e.g. test/dev/prod
 * @returns {string} root domain for the app environment
 */
function getRootDomain(env = (0, _base.getDefaultEnv)()) {
  return env === 'prod' ? 'godaddy.com' : `${env}-godaddy.com`;
}